import { useCallback, useState } from "react";
import { useAuth } from "./auth";
import { GuestUpgradeDialog } from "../components/GuestUpgradeDialog";

/**
 * Feb 2026 · DSGVO / Gast-Tier · Phase 2 Frontend-Gate (5 Sep 2026).
 *
 * Zieht ausschliesslich `user.status` (User-Directive Phase 1):
 *   status === "guest" oder "expired" → gesperrt.
 * Fuer Family gilt der Owner-Status; das Backend liefert bereits den
 * effektiven Status auf `user.status`, sodass hier keine zusaetzliche
 * Aufloesung noetig ist.
 *
 * Rueckgabe:
 *   isGuest        — bool
 *   promptUpgrade  — oeffnet das Upgrade-Modal
 *   dialog         — JSX (muss vom Consumer gerendert werden)
 *   LockIcon       — kleines Icon fuer die Button-Beschriftung
 */
export function useGuestGate() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const isGuest = user?.status === "guest" || user?.status === "expired";
  const promptUpgrade = useCallback(() => setOpen(true), []);
  const dialog = <GuestUpgradeDialog open={open} onClose={() => setOpen(false)} />;
  return { isGuest, promptUpgrade, dialog };
}
